<template>
  <div class="fit flex flex-center items-start mt-20">
    <AssetsSelect v-model="selection" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import AssetsSelect from './AssetsSelect.vue';

const selection = ref();
</script>

<style lang="scss" scoped></style>
